<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="primary" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Nueva categoria
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" md="8" sm="4" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar categoria" single-inline hide-details
                        @keydown.enter="searchTransactionCategory" placeholder="Buscar por nombre">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>
                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="transactionsCategory" class="elevation-1" fixed-header color="primary"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                    <!-- <template v-slot:top>
                        <v-toolbar flat>
                            <v-btn small dark color="primary" @click="dialog = true">
                                <v-icon left>fas fa-plus-square</v-icon>Nueva sucursal
                            </v-btn>
                            <v-toolbar-title>Listado de transactionsCategory</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template> -->
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="editTransactionCategory(item)" v-if="!item.deleted">
                                    <v-list-item-title>
                                        <v-icon small>fas fa-edit</v-icon> Editar categoria
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="removeTransactionCategory(item)" v-if="!item.deleted">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="red--text">fas fa-trash-alt</v-icon> Borrar categoria
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
        <FormTransactionCategory :transaction-category-id.sync="transactionCategoryId"
        :dialog.sync="dialog" :initialize.sync="initTableTransactionCategory"
        :transaction-type="transactionType" :handleDialog="handleDialog" v-if="dialog"/>
    </v-row>
</template>
<script>
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import TransactionCategoryService from '@/service/transactions/TransactionCategoryService';
import FormTransactionCategory from './FormTransactionCategory.vue';
import { extractMessage } from '@/helpers/errorHelper';
export default {
    name: 'ListaTransactionCategory',
    components: { Columns, FormTransactionCategory, PaginationNumber },
    mixins: [pagedTableMixin],
    created() {
        this.fetchTableData();
    },
    data() {
        return {
            transactionType: [
                { text: 'Ingreso', value: 'INCOME' },
                { text: 'Egreso', value: 'EXPENSE' }
            ],
            transactionsCategory: [],
            headers:[
                { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true },
                { text: 'ID', align: " d-none", value: 'id', visible: false, sortable: false, groupable: false, show: false },
                { text: 'Tipo de transaccion', value: 'transactionTypeNatural', sortable: false, groupable: false, show: true },
                { text: 'Nombre categoria', value: 'name', sortable: false, groupable: false, show: true },
            ],
            transactionCategoryId: null,
            dialog: false,
        }
    },
    methods:{
        searchTransactionCategory(){
            this.doSearch();
        },
        fetchTable(params){
            return TransactionCategoryService.table( params );
        },
        applyRows({ rows, total, totalPages }){
            this.transactionsCategory = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que recibe el formulario de alta y edición.
        initTableTransactionCategory(){
            this.reload();
        },
        editTransactionCategory( item ){
            this.dialog = true;
            this.transactionCategoryId = item.id;
        },
        removeTransactionCategory( item ){
            this.$swal.fire({
                title: '¿Estás seguro?',
                text: '¡No podrás revertir esto!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    TransactionCategoryService.delete(item.id).then( resp => {
                        if( resp.status == 200 ){
                            this.initTableTransactionCategory();
                            this.$swal.fire({ icon: 'success', title: '¡Hecho!', text: 'Se eliminó correctamente', footer: 'Sucursa desactivada', timer: 3500 });
                        }
                    }).catch( err => {
                        this.$swal.fire({ icon: 'error', title: 'Oops...', text: 'Algo salió mal!: ' + extractMessage(err), footer: 'Intenta de nuevo' });
                    });
                }
            });
        },
        handleDialog(){
            this.dialog = !this.dialog;
            this.transactionCategoryId = null;
        }
    },
    computed: {
        filteredHeaders() { return this.headers.filter(h => h.show); },
    }
}
</script>